import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { httpClient } from '@lib/httpClient';
import {
  CadastroImovelState,
  ICadastroImovelPayload,
  ICadastroImovelResponse
} from './types';

export const useCadastroImovelStore = create<CadastroImovelState>()(
  devtools((set) => ({
    loading: false,
    error: null,
    lastResponse: null,
    submitCadastroImovel: async (payload: ICadastroImovelPayload) => {
      set({ loading: true, error: null });
      try {
        // Normalizar campos numéricos se vierem como string
        const body = {
          ...payload,
          dormitorios:
            payload.dormitorios === '' ? null : Number(payload.dormitorios),
          suites: payload.suites === '' ? null : Number(payload.suites)
        };
        const { data } = await httpClient.post<ICadastroImovelResponse>(
          '/api/cadastre-seu-imovel',
          body
        );
        set({ loading: false, lastResponse: data });
        return data;
      } catch {
        const msg = 'Falha ao enviar cadastro do imóvel.';
        set({ loading: false, error: msg });
        return null;
      }
    }
  }))
);
